import React, { useContext, useEffect, useState } from "react";
import {
  withOrientationChange,
  isMobileOnly,
  isTablet,
  isChrome,
  isSafari,
} from "react-device-detect";

const ResponsiveContext = React.createContext({
  isPhone: false,
  isTablet: false,
  isPortrait: false,
  isChrome: true,
  isSafari: false,
});

export const useResponsiveContext = () => useContext(ResponsiveContext);

const ResponsiveContextContainer = (props) => {
  const { children, isPortrait } = props;

  const [isPhoneMode, setIsPhoneMode] = useState(
    window.matchMedia("(max-width:600px)").matches
  );
  useEffect(() => {
    window
      .matchMedia("(max-width:600px)")
      .addEventListener("change", (e) => setIsPhoneMode(e.matches));
  }, []);

  let isPhone = false;
  if (isPhoneMode) isPhone = true;
  if (isMobileOnly) isPhone = true;
  if (isTablet) isPhone = true;

  return (
    <ResponsiveContext.Provider
      value={{
        isPhone,
        isTablet,
        isPortrait,
        isChrome,
        isSafari,
      }}
    >
      {children}
    </ResponsiveContext.Provider>
  );
};

export default withOrientationChange(ResponsiveContextContainer);
